import _ from 'lodash';
import { createContext, useContext, useEffect, useMemo, useReducer } from 'react';
import { currentHelpers } from '../../redirection/current';
import { setStyleAndClass } from '../../styles/formatting';
import { DesktopContext } from '../../wrappers/DesktopWrapper';
import { pageFunctions, pageHandlers, pageInitialState, pageReducer } from '../reducers/PageReducer';
import { AppSettingsContext } from './AppSettingsContext';
import { AuthContext } from './AuthContext';
import { DemoContext } from './DemoContext';
import { PapsContext } from './PapsContext';
import { PreviewContext } from './PreviewContext';
import { CurrentSettingsContext, HomeSettingsContext } from './SettingsDataContext';
import { useStyles } from './useHelpers/useStyles';

export const PageContext = createContext();

const PageProvider = (props) => {

  // ParentContext - not available 

  // authContext
  const authContext = useContext(AuthContext)
  const { auth_state } = authContext ?? {}
  const { currentAuthUser } = auth_state ?? {}
  const { isAppDeveloper } = currentAuthUser ?? {}

  // appSettingsContext
  const appSettingsContext = useContext(AppSettingsContext);
  const { appSettings_state } = appSettingsContext ?? {}
  const { tempDataSource, settingsPreviewOn, googleSettings } = appSettings_state ?? {}

  // previewContext
  const demoContext = useContext(DemoContext)
  const { demo_state } = demoContext ?? {}

  // previewContext
  const previewContext = useContext(PreviewContext)
  const { preview_state } = previewContext ?? {}
  const { settingsPreviewHasChanged, settingsPreviewStatus, settings_googleSheets } = preview_state ?? {}

  // desktopContext
  const desktopContext = useContext(DesktopContext)
  const { desktop_state } = desktopContext ?? {}
  const { selectedPage, selectedPageItem } = desktop_state ?? {}
  const fromDesktop = desktop_state ? true : false

  // papsContext
  const papsContext = useContext(PapsContext);
  const { paps_state } = papsContext ?? {}
  const { fullSettingsKey, pathName, view, otherView, pathViews, viewKey, pageKey, landingView } = paps_state ?? {}

  const _view = fromDesktop ? selectedPage : view
  const _viewKey = fromDesktop ? selectedPageItem : viewKey

  // currentSettingsContext
  const currentSettingsContext = useContext(CurrentSettingsContext)
  const { currentSettings_state } = currentSettingsContext ?? {}
  const { settingsAreaProps: settingsAreaProps_current } = currentSettings_state ?? {}
  const { settings_currentArea: settings_currentArea_c } = settingsAreaProps_current ?? {}
  const { aps_global, aps_viewItems } = _.get(currentSettings_state, 'gvviSettings', {});

  // settingsContexts 
  const homeSettingsContext = useContext(HomeSettingsContext);

  // homeSettings
  const { homeSettings_state } = homeSettingsContext ?? {}
  const { homeSettings } = homeSettings_state ?? {}
  const { global: homeSettings_global } = homeSettings ?? {}
  const { logging: logging_home, appUrls: homeAppUrls } = homeSettings_global ?? {}

  // const styleFns = useStyles()

  // get the actual view for the page
  let trueView = (_viewKey || otherView) ? _view : _view + '_list'
  trueView = currentHelpers.getTrueView(pathViews, _view, trueView, landingView, _viewKey)

  //pageReducer
  const page_init = { homeAppUrls }
  const [page_state, page_dispatch] = useReducer(pageReducer, page_init, pageInitialState)
  const page_handlers = useMemo(
    () => pageHandlers(page_dispatch),
    [page_dispatch]
  );
  const page_functions = pageFunctions(page_state, isAppDeveloper)

  const { logging: logging_app, appDataSource } = global ?? {}

  const { aps_page } = _.get(page_state, 'pageSettings', {});

  // props
  const logging = { ...logging_home, ...logging_app }
  const { showAppSettings, showHomeSettings } = logging ?? {}

  const _aspProps = useMemo(() => {
    const aspProps = {
      appDataSource,
      pageKey,
      preview_state,
      demo_state,
      settingsAreaProps: settingsAreaProps_current,
      settingsPreviewOn,
      tempDataSource,
      trueView,
      view: _view,
      viewKey: _viewKey,
    }
    return aspProps
  }, [
    _viewKey,
    fullSettingsKey,
    googleSettings,
    pathName,
    settings_currentArea_c,
    settings_googleSheets,
    settingsAreaProps_current,
    settingsPreviewHasChanged,
    settingsPreviewOn,
    settingsPreviewStatus,
    trueView,
  ]);


  useEffect(() => {
    page_handlers.handleGetPageSettings(_aspProps)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_aspProps]);

  if (showHomeSettings) console.log('homeSettings_global', homeSettings_global)
  if (showAppSettings) console.log('aps_global', aps_global)

  const getVi = (uivi, isGlobal) => { return page_functions.getVi(uivi, isGlobal) }
  const getViRef = (uivi) => { return page_functions.getViRef(aps_viewItems, uivi, _viewKey, pathViews) }
  const getGviDeps = (uivi) => { return page_functions.getGviDeps(aps_viewItems, uivi, _viewKey, aps_page) }
  const syncViewItems = (gvs, vis, vs) => page_functions.syncViewItems(gvs, vis, vs)
  const pushDrillDown = (e, viewItem, itemData, pvKey, propItem, ddProps) => page_functions.pushDrillDown(e, homeSettingsContext, papsContext, viewItem, itemData, pvKey, propItem, ddProps)
  const getLink = (appUrlz, name, isMobileDevice) => {
    const x = _.find(appUrlz, { appName: name })
    if (x) {
      if (!isMobileDevice) {
        if (x.appDesktopUrl) {
          return x.appDesktopUrl
        } else {
          return x.appUrl
        }
      } else {
        return x.appUrl
      }
    }
  }

  const getGVIProps = (vit, viewItem, storage_fns, desktopMode) => {

    const gvi = aps_viewItems[vit]
    const { display: display_g } = gvi ?? {}
    const { display, desktopDisplay } = viewItem ?? {}
    const _display = desktopMode && desktopDisplay ? desktopDisplay : display

    let { caption, defaultIcon, iconImage, useIconImage } = display_g ?? {}

    caption = _display && _display.caption ? _display.caption : caption
    defaultIcon = _display && _display.defaultIcon ? _display.defaultIcon : defaultIcon

    iconImage = useIconImage && iconImage ? iconImage : null

    const segProps = {
      caption: caption ? caption : _.startCase(vit) + '*',
      icon: defaultIcon ? defaultIcon : 'file alternate',
      iconImage: iconImage ? iconImage : null,
      iconImageUrls: storage_fns.getIconUrl(useIconImage, iconImage)
    }

    if (caption) { segProps.caption = caption }
    if (defaultIcon) { segProps.icon = defaultIcon }

    return segProps

  }

  // functions 
  const page_fns = {
    getGviDeps,
    getVi,
    getViRef,
    pushDrillDown,
    syncViewItems,
    getLink,
    getGVIProps,
    // setStyleAndClass: (aps_global, item, opts, ignoreColors, getColors) => styleFns(  {item, opts, ignoreColors}),
    // setStyleAndClass: (aps_global, item, opts, ignoreColors, getColors) => setStyleAndClass(aps_global, item, opts, ignoreColors, getColors),
  }

  const contextProvider = () => {

    const cp = {
      homeSettings_global,
      logging,
      page_fns,
      page_handlers,
      page_state,
    }

    return <PageContext.Provider value={cp}>
      {props.children}
    </PageContext.Provider>
  }

  return aps_page ? contextProvider() : <div>No aps_page</div>
}

export default PageProvider